// import React, { useRef } from "react";
// import { motion } from "framer-motion";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "../CourseSlider.css";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// const courses = [
//   {
//     image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?w=600",
//     title: "Cybersecurity Fundamentals",
//     tag: "Cybersecurity",
//     desc: "AI-powered web design refers to the  of AI technologies...",
//   },
//   {
//     image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?w=600",
//     title: "Full Stack Web Development",
//     tag: "Full Stack",
//     desc: "Master MERN stack and build industry-level products...",
//   },
//   {
//     image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?w=600",
//     title: "Data Science & Analytics",
//     tag: "Data Science",
//     desc: "Learn Machine Learning, Python, Analytics and more...",
//   },
//   {
//     image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?w=600",
//     title: "Cloud Computing",
//     tag: "Cloud",
//     desc: "Deploy real projects using AWS, Azure and DevOps tools...",
//   },
// ];

// export default function CourseSlider() {
//   const swiperRef = useRef(null);

//   return (
//     <motion.div
//       initial={{ scale: 0.7, opacity: 0 }}
//       whileInView={{ scale: 1, opacity: 1 }}
//       viewport={{ once: true, amount: 0.3 }}
//       transition={{ duration: 0.8, ease: "easeOut" }}
//       className="course-slider-section"
//     >
//       <h2
//         style={{
//           textAlign: "center",
//           marginBottom: "20px",
//           padding: "40px",
//           fontSize: "2.5rem",
//           fontWeight: "900",
//           letterSpacing: "0.8px",
//         }}
//       >
//         {" "}
//         Popular Courses
//       </h2>
//       <div className="courses-desc">
//         Industry-focused programs designed for your success
//       </div>
//       <Swiper
//         modules={[Pagination, Autoplay]}
//         spaceBetween={-40}
//         slidesPerView={3}
//         loop
//         pagination={{ clickable: true }}
//         autoplay={{ delay: 3000 }}
//         onSwiper={(swiper) => (swiperRef.current = swiper)}
//       >
//         {courses.map((course, i) => (
//           <SwiperSlide key={i}>
//             <div className="course-card">
//               <img
//                 src={course.image}
//                 alt={course.title}
//                 className="course-image"
//               />

//               <div className="course-content">
//                 <span className="course-tag">{course.tag}</span>
//                 <h3>{course.title}</h3>
//                 <p>{course.desc}</p>

//                 <button className="enroll-btn">Enroll Now</button>
//               </div>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>

//       <div className="arrow-controls">
//         <button
//           onClick={() => swiperRef.current.slidePrev()}
//           className="arrow-btn"
//         >
//           ⬅
//         </button>
//         <button
//           onClick={() => swiperRef.current.slideNext()}
//           className="arrow-btn"
//         >
//           ➡
//         </button>
//       </div>
//     </motion.div>
//   );
// }

import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "../CourseSlider.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";

const courses = [
  {
    image:
      "https://images.unsplash.com/photo-1629904853893-c2c8981a1dc5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fEN5YmVyc2VjdXJpdHl8ZW58MHx8MHx8fDA%3D",
    title: "Cybersecurity Fundamentals",
    tag: "Cybersecurity",
    desc: "Cyber Security trains you to detect threats, secure networks, and protect critical data.",
    path: "/cyber-security",
  },
  {
    image:
      "https://images.unsplash.com/photo-1624996752380-8ec242e0f85d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8V2ViJTIwRGV2ZWxvcG1lbnR8ZW58MHx8MHx8fDA%3D",
    title: "Full Stack Web Development",
    tag: "Full Stack",
    desc: "Full Stack Web Development teaches you to build scalable, user-focused web applications.",
    path: "/web-development",
  },
  {
    image:
      "https://plus.unsplash.com/premium_photo-1661878265739-da90bc1af051?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8RGF0YSUyMFNjaWVuY2V8ZW58MHx8MHx8fDA%3D",
    title: "Data Science & Analytics",
    tag: "Data Science",
    desc: "Data Science uses statistics and machine learning to extract insights and predict outcomes.",
    path: "/data-science",
  },
  {
    image:
      "https://plus.unsplash.com/premium_photo-1683120968693-9af51578770e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y2xvdWQlMjBjb21wdXRpbmd8ZW58MHx8MHx8fDA%3D",
    title: "Cloud Computing",
    tag: "Cloud",
    desc: "Cloud Computing teaches you to deploy, manage, and secure applications on scalable systems.",
    path: "/cloud-computing",
  },
];

export default function CourseSlider() {
  const swiperRef = useRef(null);
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ scale: 0.7, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="course-slider-section"
    >
      <h2
        style={{
          textAlign: "center",
          marginTop: "40px",
          marginBottom: "20px",
          padding: "40px",
          fontSize: "2.5rem",
          fontWeight: "900",
          letterSpacing: "0.8px",
        }}
      >
        {" "}
        Master the Skills That Matter Today
      </h2>
      <div className="courses-desc">
        Industry-aligned courses built for tomorrow’s achievers.
      </div>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 1.2, spaceBetween: 10 }, 
          768: { slidesPerView: 2, spaceBetween: 15 }, 
          1024: { slidesPerView: 3, spaceBetween: 25 }, 
        }}
        loop
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {courses.map((course, i) => (
          <SwiperSlide key={i}>
            <div className="course-card">
              <img
                src={course.image}
                alt={course.title}
                className="course-image"
              />

              <div className="course-content">
                <span className="course-tag">{course.tag}</span>
                <h3>{course.title}</h3>
                <p>{course.desc}</p>

                {/* <button className="enroll-btn">Enroll Now</button> */}
                <button
                  className="enroll-btn"
                  onClick={() => navigate(course.path)}
                >
                  Enroll Now
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="arrow-controls">
        <button
          onClick={() => swiperRef.current.slidePrev()}
          className="arrow-btn"
        >
          ⬅
        </button>
        <button
          onClick={() => swiperRef.current.slideNext()}
          className="arrow-btn"
        >
          ➡
        </button>
      </div>
    </motion.div>
  );
}
